export class DeleteVendorContractParameterDto {
    deleteAllDocuments: boolean;
    vendorContractId: number;
    communityVendorId: number;
    vendorCode: string;
    communityId: number;
    clearCache: boolean;
}
